import React, {ReactNode} from "react";
import {getProducerBuilding} from "../../enum/Resource";
import {boosterIndexToGid, Step as StepType, StepAction, VillageState as VillageStateType} from "../../Calculator/ResourceUpgradeOrder";
import {TranslationNode} from "../../../translate";
import {ImageOasisGeneric} from "../../Components/ImageMisc/ImageOasis";
import {useTranslationContext} from "../../../react/providers/TranslationContext";

type Props = {
    village: VillageStateType,
    step: StepType,
}

export function Step({ village, step }: Props): ReactNode {
    const {getTranslator} = useTranslationContext();
    const translate = getTranslator('tool/trav/ResourceUpgradeOrder');
    const rootTranslate = getTranslator('');

    switch (step.action) {
        case StepAction.annectOasis:
            return <><TranslationNode translate={translate} tKey={'stepAnnectOasis'}/> <ImageOasisGeneric size={16}
                                                                                                          oasis={step.oasis}/></>
        case StepAction.upgradeField:
            const fieldName = rootTranslate('travian/building_' + getProducerBuilding(village.resourceTypes[step.upgradeIndex]));
            return <TranslationNode translate={translate} tKey={'stepUpgradeField'} params={{
                field: fieldName,
                from: step.upgradeFrom.toString(),
                to: step.upgradeTo.toString()
            }}/>
        case StepAction.upgradeOasisBuilding:
            return <TranslationNode translate={translate} tKey={'stepUpgradeOasisBuilding'}
                                    params={{from: step.upgradeFrom.toString(), to: step.upgradeTo.toString()}}/>
        case StepAction.upgradeWaterworks:
            return <TranslationNode translate={translate} tKey={'stepUpgradeWaterworks'}
                                    params={{from: step.upgradeFrom.toString(), to: step.upgradeTo.toString()}}/>
        case StepAction.upgradeBooster:
            const boosterGid = boosterIndexToGid[step.upgradeIndex];
            const boosterName = rootTranslate('travian/building_' + boosterGid);
            return <TranslationNode translate={translate} tKey={'stepUpgradeBooster'} params={{
                name: boosterName,
                from: step.upgradeFrom.toString(),
                to: step.upgradeTo.toString()
            }}/>
    }
}
